import {
  Component,
  OnInit,
  Input,
  HostListener,
  HostBinding,
} from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from '@services';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  isOpen = false;
  @Input() name: string;
  @Input() type: 'video' | 'no-x-close' | 'table' | '' = '';
  @Input() redirectTo: string = '';
  @Input() blockCloseModalOnClickOutside: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() positionFloating: string;
  @Input() hasShadow: boolean;

  @HostBinding('class.avla_modal--open') get valid() {
    return this.isOpen;
  }
  @HostBinding('class.avla_modal--close') get invalid() {
    return !this.isOpen;
  }

  constructor(private router: Router, private modalService: ModalService) {}

  ngOnInit() {
    this.modalService.change.subscribe((modal) => {
      if (modal && modal.name === this.name) {
        this.isOpen = modal.isOpen;
      }
    });
    this.modalService.register(this.name);
  }

  get getPositionFloating() {
    const floating = this.positionFloating;
    return floating === 'top' ? 'to-top-position' : 'to-bottom-position';
  }

  toggle(event) {
    this.modalService.close(this.name);
    this.redirectTo !== '' && this.router.navigate([this.redirectTo]);
  }

  @HostListener('click', ['$event.target'])
  onClick(target) {
    if (target.tagName === 'APP-MODAL' && !this.blockCloseModalOnClickOutside) {
      this.modalService.close(this.name);
    }
  }

  get getClassess() {
    return {
      'full-width': this.fullWidth,
      [this.type]: true,
      'to-top-position': this.positionFloating === 'top',
      'to-bottom-position': this.positionFloating !== 'top',
    };
  }
}
